/* depricated functional */
// function setEditMainImg() {
//   let firstImg = $(
//     '.edit-img-small__img-wrap.js-sortable-item:first-of-type'
//   ).attr('data-edit-img');
//   $('.edit-img-main__img').attr('src', firstImg);
//   if ($('.ie-11').length) {
//     $('.edit-img-main__img').attr(
//       'style',
//       'background-position: center; background-image: url("' +
//         firstImg +
//         '"); background-repeat: no-repeat; background-size: cover; background-origin: content-box;'
//     );
//   }
// }

$('.js-sortable').sortable({
  items: '.js-sortable-item',
  scroll: false,
});
$('.js-sortable').disableSelection();
/* вставляет в плейсхолдер изображение перетаскиваемой картинки */
$(document).on('touchmove mousemove', '.js-sortable-item', function (e) {
  let img = $(this).find('img').attr('src');
  if (
    $('.ui-sortable-placeholder').attr('style') !=
    'background-image:url(' + img + ')'
  ) {
    $('.ui-sortable-placeholder').attr(
      'style',
      'background-image:url(' + img + ')'
    );
  }
});
$('.js-sortable-item').on(
  'touchstart',
  '.js-exclude-from-sortable',
  function (e) {
    $('.js-sortable').sortable('disable');
  }
);
$('.js-sortable-item').on(
  'touchend',
  '.js-exclude-from-sortable',
  function (e) {
    $('.js-sortable').sortable('enable');
  }
);

$('.js-sortable').on('sortstart', function (event, ui) {
  $(this).sortable('refreshPositions');
});
// $('.js-sortable').on('sortstop', function (event, ui) {
//   // setEditMainImg();
// });

$(document).on('click', '.js-edit-car-sortable', function () {
  setTimeout(function () {
    $('.js-sortable').sortable();
  }, 250);
});

// $(document).on(
//   'click touch',
//   '.edit-img-small__controls-item.js-remove-closest-target',
//   function (e) {
//     setEditMainImg();
//   }
// );

/* depricated functional */
// $(document).on('click', '.js-remove-edit-main-img', function () {
//   $('.edit-img-small__img-wrap.js-sortable-item:first-of-type').remove();
//   setEditMainImg();
// });

const smallImgCount = () => {
  let count = $('.js-small-img-count').length;
  if (count < 10) {
    $('#additional-photo-col').addClass('active');
  } else {
    $('#additional-photo-col').removeClass('active');
  }
};
$(document).on('click', '.js-small-img-count-btn-remove', function () {
  smallImgCount();
});
$(document).ready(function () {
  smallImgCount();
});
